const featuresConfig = {
  features: {
    analytics: {
      name: 'Features'
    }
  },
  windResistances: {
    analytics: {
      name: 'Wind Resistance'
    }
  },
  impactResistances: {
    analytics: {
      name: 'Impact Resistance'
    }
  },
  warranties: {
    analytics: {
      name: 'Warranty'
    }
  }
}

export default featuresConfig;
